import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../../supabaseClient';

const C = {
  navy: '#0b1120',
  navyLight: '#111a2e',
  blue: '#6699ff',
  cream: '#f5f0e8',
  creamLight: '#faf7f2',
  creamWarm: '#ede5d8',
  textDark: '#0d1520',
  textBody: '#3a4860',
  white: '#ffffff',
};

export default function AdminLayout({ children, title }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/spc-portal-1003/login');
  };

  const navItems = [
    { label: 'Dashboard', path: '/spc-portal-1003' },
    { label: 'New Article', path: '/spc-portal-1003/articles/new' },
    { label: 'Publications', path: '/spc-portal-1003/publications' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: C.creamLight, fontFamily: "'Manrope', sans-serif" }}>
      {/* Top Bar */}
      <div style={{
        background: C.navy, padding: '0 40px', height: 64,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        borderBottom: '1px solid rgba(102,153,255,0.12)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 32 }}>
          <span
            onClick={() => navigate('/spc-portal-1003')}
            style={{ fontSize: 12, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: C.cream, cursor: 'pointer' }}
          >
            SPC <span style={{ color: C.blue }}>Admin</span>
          </span>

          <div style={{ display: 'flex', gap: 4 }}>
            {navItems.map(item => {
              const active = location.pathname === item.path;
              return (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  style={{
                    padding: '8px 20px', border: 'none', borderRadius: 2,
                    background: active ? 'rgba(102,153,255,0.15)' : 'transparent',
                    color: active ? C.blue : 'rgba(245,240,232,0.5)',
                    fontFamily: "'Manrope', sans-serif", fontSize: 12, fontWeight: 600,
                    letterSpacing: 1, textTransform: 'uppercase', cursor: 'pointer',
                    transition: 'all 0.2s ease',
                  }}
                >
                  {item.label}
                </button>
              );
            })}
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
          <button
            onClick={() => navigate('/')}
            style={{
              padding: '8px 16px', border: '1px solid rgba(245,240,232,0.15)',
              background: 'transparent', color: 'rgba(245,240,232,0.5)',
              fontFamily: "'Manrope', sans-serif", fontSize: 11, fontWeight: 500,
              letterSpacing: 1, cursor: 'pointer', transition: 'all 0.2s ease',
            }}
          >
            View Site
          </button>
          <button
            onClick={handleLogout}
            style={{
              padding: '8px 16px', border: 'none',
              background: 'rgba(239,68,68,0.15)', color: '#f87171',
              fontFamily: "'Manrope', sans-serif", fontSize: 11, fontWeight: 600,
              letterSpacing: 1, textTransform: 'uppercase', cursor: 'pointer',
            }}
          >
            Sign Out
          </button>
        </div>
      </div>

      {/* Page Header */}
      {title && (
        <div style={{ padding: '32px 40px 0', maxWidth: 1200, margin: '0 auto' }}>
          <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 32, fontWeight: 500, color: C.textDark }}>
            {title}
          </h1>
        </div>
      )}

      {/* Content */}
      <div style={{ padding: '24px 40px 60px', maxWidth: 1200, margin: '0 auto' }}>
        {children}
      </div>
    </div>
  );
}